/**
 * UTM Capture for Gravity Forms
 *
 * Captures UTM parameters and ad-platform click IDs (gclid, fbclid, etc.)
 * from the URL into a cookie so Gravity Forms hidden fields can be populated
 * even after the visitor navigates away from the landing page.
 *
 * Last-touch: new values in the URL overwrite any previously stored values.
 * The cookie is read server-side in includes/mods-form.php.
 */
(function () {
  'use strict';

  // ---------- Settings ----------

  var COOKIE_NAME = 'utm_attribution';
  var COOKIE_DAYS = 3;

  // Non-UTM params we also capture (no shared prefix, so listed explicitly).
  var CLICK_ID_PARAMS = ['gclid', 'fbclid', 'msclkid', 'ttclid'];

  // ---------- Helpers ----------

  function getCookie(name) {
    var pattern = new RegExp('(?:^|;\\s*)' + name + '=([^;]+)');
    var match = document.cookie.match(pattern);
    return match ? decodeURIComponent(match[1]) : null;
  }

  // SameSite=Lax: cookie is sent on top-level navigations (form submits on
  // this site) but not on most third-party requests.
  function setCookie(name, value, days) {
    var millisecondsPerDay = 24 * 60 * 60 * 1000;
    var expirationDate = new Date(Date.now() + days * millisecondsPerDay);

    var cookieParts = [
      name + '=' + encodeURIComponent(value),
      'expires=' + expirationDate.toUTCString(),
      'path=/',
      'SameSite=Lax'
    ];

    document.cookie = cookieParts.join(';');
  }

  function isAttributionParam(paramName) {
    return paramName.indexOf('utm_') === 0
      || CLICK_ID_PARAMS.indexOf(paramName) !== -1;
  }

  function readStoredValues() {
    var raw = getCookie(COOKIE_NAME);
    if (!raw) return {};

    try {
      return JSON.parse(raw) || {};
    } catch (err) {
      return {};
    }
  }

  // ---------- Main ----------

  if (!window.URLSearchParams || !window.location.search) {
    return;
  }

  var urlParams = new URLSearchParams(window.location.search);
  var storedValues = readStoredValues();
  var somethingChanged = false;

  urlParams.forEach(function (value, key) {
    // Lowercase so "UTM_Source" and "utm_source" are treated the same.
    var paramName = key.toLowerCase();

    if (!isAttributionParam(paramName)) return;
    if (storedValues[paramName] === value) return;

    // Overwrites the previous value — last-touch attribution.
    storedValues[paramName] = value;
    somethingChanged = true;
  });

  if (!somethingChanged) return;

  var serialized = JSON.stringify(storedValues);
  setCookie(COOKIE_NAME, serialized, COOKIE_DAYS);

  // Mirror to sessionStorage as a convenience for other scripts.
  // try/catch because some private-browsing modes block sessionStorage.
  try {
    window.sessionStorage.setItem(COOKIE_NAME, serialized);
  } catch (err) {}
})();
